<template>
    <div class="nav-wrapper">
        <ul class="nav-scroller">
            <li v-for="(value, key, index) in newsTypeCh" :type="newsType[key]" :class="index == 0 ? 'active' : ''" @click='switchTag'><a class="cat" href="javascript:;">{{value}}</a></li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'Header',
  data () {
    return {
      newsType: {   // 更换tab即可更新类别，更换tab信息时，注意同时更新newsTypeCh
          tab1 : 'recommend',
          tab2 : 'entertainment',
          tab3 : 'society'
          // tab4 : 'junshi'
      },
      newsTypeCh : {    // tab信息的中文名
          tab1 : '推荐',
          tab2 : '娱乐',
          tab3 : '社会'
          // tab4 : '军情'
      }
    }
  },
  created : function() {
    this.pipe.$on('getNewsType', () => {
        this.pipe.$emit('listen', {func : 'getNewsType', param1 : this.getNowNewsType()})
    });
  },
  methods:{
    //切换标签
    switchTag(event){
        var e = event.currentTarget;
        if ($(e).hasClass('active'))
        {
            return;
        }
        else
        {
            $(e).addClass('active').siblings().removeClass('active');
            this.pipe.$emit('listen', 'clickToChangeTab')
        }
    },
    getNowNewsType (){
        var newsType;
        var tabName = $('.active').find('a').html();
        for (var i in this.newsTypeCh) {
            if (tabName === this.newsTypeCh[i]) {
                newsType =  this.newsType[i];
                break ;
            }
        }
        return newsType ? newsType : this.newsType.tab1;
    }
  }
}
</script>
